import React from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import favicon from '../../static/favicon-32x32.png';

const SEO = props => (
  <StaticQuery
    query={detailsQuery}
    render={data => {
      const { siteMetadata } = data.site;
      const title = props.title || siteMetadata.title;
      const description = props.description || siteMetadata.description;
      const siteUrl = siteMetadata.siteUrl;
      const canonical = props.path ? `${siteUrl}${props.path}` : siteUrl;
      const ogImage = props.ogImage || `${siteUrl}/images/og-default.png`;

      return (
        <Helmet
          htmlAttributes={{ lang: 'zh-CN' }}
          title={title}
          titleTemplate={props.title ? `%s` : `%s - ${siteMetadata.title}`}
          meta={[
            { name: 'description', content: description },
            { property: 'og:title', content: title },
            { property: 'og:description', content: description },
            { property: 'og:type', content: 'website' },
            { property: 'og:url', content: canonical },
            { property: 'og:image', content: ogImage },
            { property: 'og:site_name', content: '魔鬼鱼订货平台' },
            { property: 'og:locale', content: 'zh_CN' },
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: title },
            { name: 'twitter:description', content: description }
          ]}
          link={[
            { rel: 'shortcut icon', type: 'image/png', href: favicon },
            { rel: 'canonical', href: canonical }
          ]}
        />
      );
    }}
  />
);

SEO.defaultProps = {
  lang: 'zh-CN',
  meta: [],
  keywords: []
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        siteUrl
      }
    }
  }
`;
